module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "date col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [_vm._v("\n      " + _vm._s(_vm.date) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "source col-xs-6 col-sm-4 col-md-4 col-lg-2"
  }, [_vm._v("\n      " + _vm._s(_vm.reference) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "amount col-xs-12 col-sm-4 col-md-5 col-lg-8 text-right"
  }, [_vm._v("\n      " + _vm._s(_vm.paid) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-48d6bd03"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoices/InvoicePaymentItem.vue
// module id = 991
// module chunks = 0